import React, { Component } from "react";

import axios from "axios";
import $ from "jquery";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import Header from "../common/Header";
import Sidebar from "./Sidebar";
import Avatar from "../assets/img/default-user-avatar.png";

var _name,
  _description,
  _initial,
  _price,
  _type,
  _duration,
  _plan_code

export class EditHome extends Component {
  constructor(props) {
    super(props);
    // let { user } = this.props.appstate;
    this.state = {
      token: localStorage["appState"]
        ? JSON.parse(localStorage["appState"]).user.token
        : "",
      user: [],
      imageSource: "",
      file: null,
      home: [],
      home_id: "",
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    // //console.log(id);
    this.getUser();
    this.getHome();
  }

  getUser(){
    axios
    .get(
      `${axios.defaults.baseURL}/user/${
        JSON.parse(localStorage["appState"]).user.id
      }`,
      {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      }
    )
    .then((response) => {
      //console.log(response);
      return response;
    })
    .then((json) => {
      if (json.data.success) {
        this.setState({ user: json.data.user[0] });
        // } else alert("Cannot Fetch Data!");
      } else swal("Oops!", "Cannot Fetch Data!", "error");
    })
    .catch((error) => {
      console.error(`An Error Occured! ${error}`);
    });
  }

  getHome(){

    var id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];
    axios
      .get(`${axios.defaults.baseURL}/view-home/${id}`)
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({
            home: json.data.home[0],
            plan: json.data.home[0].plan_code,
            home_id: json.data.home[0].id,
          });
        } else {
          //console.log(`Cannot fetch data!`);
        }
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  }

  handleUpdate = (e) => {
    e.preventDefault();

    $("#update-profile")
      .attr("disabled", "disabled")
      .html(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span class="sr-only">Loading...</span>'
      );

    var formData = new FormData();
    formData.append("name", _name.value);
    formData.append("description", _description.value);
    formData.append("image", this.state.file != "" ? this.state.file : this.state.home.image);
    formData.append("initial", _initial.value);
    formData.append("price", _price.value);
    formData.append("type", _type.value);
    formData.append("duration", _duration.value);
    formData.append("plan_code", _plan_code.value);

    //console.log(formData);

    axios({
      method: "post",
      url: `${axios.defaults.baseURL}/edit-home/${this.state.home.id}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${this.state.token}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success === true) {
          swal("Updated!", "" + json.data.message, "success", {
            button: false,
            timer: 1500,
          });
          $("#update-profile").removeAttr("disabled").html("Update Home");
          // redirect home
          this.props.history.push("/admin/evest-list");
        } else {
          // alert(json.data.message);
          swal("Alert!", "" + json.data.message, "warning");
          $("#update-profile").removeAttr("disabled").html("Update Home");
        }
      })
      .catch((error) => {
        // alert("An Error Occured!" + error);
        //console.log(error.response.data);
          swal("Warning!", "Please fill all fields", "warning");
            $("#update-profile").removeAttr("disabled").html("Update Home");
      });
  };

  // onChange(e) {
  //   this.setState({file:e.target.files[0]});
  // }

  uploadPhoto = (e) => {
    this.photoUpload.click();
  };

  onChange = (event) => {
    this.setState({
      imageSource: "",
      imageData: "",
      file: event.target.files[0],
    });
    const file = event.target.files[0];
    //console.log(file);

    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.setState({
          imageSource: event.target.result,
          imageData: file,
        });
      };
    }
  };

  render() {
    $("#name-input").attr("value", this.state.home.name);
    $("#description-input").attr("value", this.state.home.description);
    $("#initial-input").attr("value", this.state.home.initial);
    $("#price-input").attr("value", this.state.home.price);
    $("#type-input").attr("value", this.state.home.type);
    $("#duration-input").attr("value", this.state.home.duration);
    $("#plan_code-input").attr("value", this.state.home.plan_code);

    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div data-v-4c22b934="">
                    <div data-v-4c22b934="" id="profile-page">
                      <div className="page-title">
                        <div className="row text-primary py-2 pt-4">
                          <div className="col-10">
                            <div
                              className="user-welcome"
                              style={{ overflow: "hidden" }}
                            >
                                <Link to="/admin/evest-list">
                                    <i className="ti-arrow-left"></i> Back to Homes List
                                </Link>
                              <div className="wrapper d-flex mt-2">
                                <h4 className="d-inline-block">Edit {this.state.home.name} <i className="fa fa-pencil"></i></h4>
                              </div>
                            </div>
                          </div>
                          <div className="text-right col-2"></div>
                        </div>
                      </div>
                      <div className="pb-5">
                        <div className="row">
                          <div className="col-12">
                            <div className="wrapper dash-card bg-white">
                              <div className="p-4 text-center">
                                <img
                                  src={
                                    this.state.imageSource
                                      ? this.state.imageSource :
                                      this.state.home.image ?
                                      this.state.home.image
                                      : Avatar
                                  }
                                  id="user-logo"
                                  className="shadow-xl plan-img"
                                />
                                <p
                                  role="button"
                                  onClick={this.uploadPhoto}
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  Change Image
                                </p>
                              </div>
                              <hr className="mt-0"></hr>
                              <div className="px-4">
                                <h5 className="mb-0">Home Information</h5>
                              </div>
                              <form
                                id="reg"
                                action=""
                                onSubmit={this.handleUpdate}
                                method="post"
                              >
                                <input
                                  ref={(input) => (this.photoUpload = input)}
                                  onChange={this.onChange}
                                  autoComplete="off"
                                  id="image-input"
                                  name="image"
                                  type="file"
                                  hidden
                                />
                                <div className="p-4">
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Name
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_name = input)}
                                          id="name-input"
                                          name="name"
                                          type="text"
                                          
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Description
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_description = input)}
                                          id="description-input"
                                          name="description"
                                          type="text"
                                          
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Initial Deposit (₦)
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_initial = input)}
                                          id="initial-input"
                                          name="initial"
                                          type="text"
                                          
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Installmental Payments (₦)
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_price = input)}
                                          id="price-input"
                                          name="price"
                                          type="text"
                                          
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Type
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <select
                                          ref={(input) => (_type = input)}
                                          id="type-input"
                                          name="type"
                                          type="text"
                                          
                                          aria-required="true"
                                          className="form-control"
                                        >
                                          <option value="monthly">Monthly</option>
                                          <option value="weekly">Weekly</option>
                                          <option value="daily">Daily</option>
                                        </select>
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Duration
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_duration = input)}
                                          id="duration-input"
                                          name="duration"
                                          type="text"
                                          
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Plan Code
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_plan_code = input)}
                                          id="plan_code-input"
                                          name="plan_code"
                                          type="text"
                                          
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <div className="text-center">
                                    <button
                                      id="update-profile"
                                      type="submit"
                                      className="btn btn-primary my-4"
                                    >
                                      Update Home
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditHome;
